import request from '@/utils/http';

// const getDetail = (id) => request({
//   method: 'get',
//   url: 'get-order-info',
//   params: { id },
// });
const getDetail = (params) => request({
  method: 'get',
  url: 'get-order-info',
  params,
});
const getList = async (params) => request({
  method: 'get',
  url: 'get-order-list',
  params,
});

const createOrder = (data) => request({
  method: 'post',
  url: 'create-order',
  data,
});
const createTwoOrder = (data) => request({
  method: 'post',
  url: 'create-two-order',
  data,
});
const createTicketOrder = (data) => request({
  method: 'post',
  url: 'create-ticket-order',
  data,
});
const createBpOrder = (data) => request({
  method: 'post',
  url: 'create-bp-order',
  data,
});


const cancelOrder = (data) => request({
  method: 'post',
  url: 'cancel-order',
  data,
});

const pay = (data) => request({
  method: 'get',
  url: 'get-payinfo',
  data,
});

export default {
  getDetail,
  createOrder,
  createTicketOrder,
  createTwoOrder,
  cancelOrder,
  pay,
  getList,
	createBpOrder,
};
